/**  */
import i18n from "@/lib/i18n";

export const required = (val: unknown) => {
  if (!val) return i18n.t("form_validation.required");
};
